var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"patient-dob"},[_c('b-badge',{attrs:{"variant":_vm.variant}},[(_vm.showLabel)?[_vm._v("DOB")]:_vm._e(),_vm._v("\n        "+_vm._s(_vm.dateString)+"\n    ")],2)],1)}
var staticRenderFns = []

export { render, staticRenderFns }